(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-subcategory-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var BP = '(min-width: 750px)';
    // Wrap dynamic import so Shopify's esbuild bundler does not rewrite it to require()
    var dynImport = new Function('u', 'return import(u);');

    function whenFluReady(cb) {
      if (window.flu && window.flu.chunks && window.flu.chunks.swiper) return cb();
      var tries = 0;
      var timer = setInterval(function () {
        tries++;
        if (window.flu && window.flu.chunks && window.flu.chunks.swiper) {
          clearInterval(timer);
          cb();
        } else if (tries > 50) {
          clearInterval(timer);
        }
      }, 100);
    }

    function setupNav(nav) {
      if (!nav || nav.dataset.carousel !== 'true' || nav._subnavInit) return;
      nav._subnavInit = true;

      var wrap = nav.querySelector('.collection-subnav__scroll-wrap');
      var list = nav.querySelector('.collection-subnav__list');
      if (!wrap || !list) return;
      var items = Array.prototype.slice.call(list.querySelectorAll('.collection-subnav__item'));
      var nextEl = nav.querySelector('[data-next]');
      var prevEl = nav.querySelector('[data-prev]');

      var layoutD = nav.dataset.layoutDesktop;
      var layoutM = nav.dataset.layoutMobile;
      var pvD = parseFloat(nav.dataset.pvDesktop) || 5;
      var pvM = parseFloat(nav.dataset.pvMobile) || 2;
      var spaceD = parseInt(nav.dataset.spaceDesktop, 10) || 0;
      var spaceM = parseInt(nav.dataset.spaceMobile, 10) || 0;
      var useArrows = nav.dataset.arrows === 'true';

      var mql = window.matchMedia(BP);
      var swiper = null;

      function wantCarousel() {
        return mql.matches ? layoutD === 'carousel' : layoutM === 'carousel';
      }
      function addClasses() {
        wrap.classList.add('swiper');
        list.classList.add('swiper-wrapper');
        items.forEach(function (i) { i.classList.add('swiper-slide'); });
        nav.classList.add('is-carousel');
      }
      function removeClasses() {
        wrap.classList.remove('swiper');
        list.classList.remove('swiper-wrapper');
        items.forEach(function (i) { i.classList.remove('swiper-slide'); });
        nav.classList.remove('is-carousel');
      }
      var isPills = nav.classList.contains('collection-subnav--pills');
      function build() {
        addClasses();
        dynImport(window.flu.chunks.swiper).then(function (mod) {
          if (!nav.classList.contains('is-carousel')) return;
          var opts = {
            modules: [mod.Navigation],
            slidesPerView: isPills ? 'auto' : pvM,
            spaceBetween: spaceM,
            watchOverflow: true,
            breakpoints: { 750: { slidesPerView: isPills ? 'auto' : pvD, spaceBetween: spaceD } }
          };
          if (useArrows && nextEl && prevEl) {
            opts.navigation = { nextEl: nextEl, prevEl: prevEl };
          }
          swiper = new mod.Swiper(wrap, opts);
        });
      }
      function destroy() {
        if (swiper) {
          try { swiper.destroy(true, true); } catch (e) {}
          swiper = null;
        }
        removeClasses();
      }
      function apply() {
        if (wantCarousel()) {
          if (!swiper) build();
        } else {
          destroy();
        }
      }

      apply();
      var onChange = function () { apply(); };
      if (mql.addEventListener) mql.addEventListener('change', onChange);
      else mql.addListener(onChange);

      nav._subnavTeardown = function () {
        if (mql.removeEventListener) mql.removeEventListener('change', onChange);
        else mql.removeListener(onChange);
        destroy();
        nav._subnavInit = false;
      };
    }

    function initAll(root) {
      var scope = root || document;
      var navs = scope.querySelectorAll('.collection-subnav[data-carousel="true"]');
      Array.prototype.forEach.call(navs, function (nav) {
        whenFluReady(function () { setupNav(nav); });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      var nav = e.target.querySelector('.collection-subnav');
      if (nav && nav._subnavTeardown) nav._subnavTeardown();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
